import { errorLevel } from 'constants/errors';
import { treatErrorAs } from 'api/errors';
import { getAllActivitiesByActivityType, getActivityCategoriesByActivityType } from 'activities/selectors';
import { getActiveFieldId } from 'current/selectors';
import { getAllFields } from 'fields/selectors';
import {
  findActivity,
  findActivityCategories,
  findActivityDefaultDates,
  findActivitiesForFieldUuid
} from 'activities/finders';
import { findProductYears } from 'settings/finders';
import { findFieldBoundariesByFieldUuid } from 'boundaries/finders';
import { extractFieldIdentifier } from 'fields/utils';


export const requestActivities = () => {
  return (dispatch, getState) => {
    let state = getState();
    const fields = getAllFields(state);
    const fieldId = getActiveFieldId(state);
    const fieldUuid = extractFieldIdentifier({ fields, id:fieldId }).uuid;

    return findFieldBoundariesByFieldUuid({ dispatch, getState, fieldUuid })
    .then( () => Promise.all([
      findProductYears({ dispatch, getState })
      .catch( treatErrorAs({ severity: errorLevel.INFO }) ),

      findActivityCategories({ dispatch, getState })
      .catch( treatErrorAs({ severity: errorLevel.WARN }) ),

      findActivitiesForFieldUuid({ dispatch, getState, fieldUuid })
      .catch( treatErrorAs({ severity: errorLevel.WARN }) )
    ]))
    .then( () => {
      findActivityDefaultDates({ dispatch, getState })
      .catch( treatErrorAs({ severity: errorLevel.WARN }) );
    })
    // immediately loop through existing activities and run findActivity with the associated activity
    // category uuid to get the activity updated to the current season, if needed
    .then( () => {
      state = getState();
      const activities = getAllActivitiesByActivityType(state);
      const activityCategories = getActivityCategoriesByActivityType(state);
      // for each currently existing activity
      Object.values(activities).forEach(({ type }) => {
        // retrieve the category it belongs to
        const activityCategory = activityCategories[type];
        // call find activity with the category uuid and activity type -- this
        // will handle putting the updated activity in state if a new one was created/fetched
        return findActivity({ dispatch, getState, params: activityCategory })
        .catch( treatErrorAs({ severity: errorLevel.WARN }) );
      });
    });
  };
};
